import { useUndoRedo } from '@hooks/useUndoRedo'
import { useEffect } from 'react'

function isUndoRedoShortcut(event: KeyboardEvent): boolean {
  const key = event.key.toLowerCase()
  const withMeta = event.metaKey || event.ctrlKey
  if (!withMeta) return false
  return key === 'z' || key === 'y'
}

export function useRollback() {
  const { performUndo, performRedo } = useUndoRedo()

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (!isUndoRedoShortcut(event)) return

      const key = event.key.toLowerCase()
      if (key === 'z' && !event.shiftKey) {
        event.preventDefault()
        performUndo()
        return
      }

      if (key === 'y' || (key === 'z' && event.shiftKey)) {
        event.preventDefault()
        performRedo()
      }
    }

    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [performUndo, performRedo])
}
